import { useTranslation } from 'react-i18next';
import UserService from '../../../services/UserService';
import { getStatusTranslationKey, isMessageTooOld,GetMessageStatusColor } from '../DashboardUtilities';
import RenderOnRole from "../../../Utilities/RenderOnRole";
import CopyBtn from './CopyBtn';

// ============================================================================
// MAIN COMPONENT
// ============================================================================

const MessageRow = ({ message, index, isSelected, onToggle, hasScsnValues }) => {
  const { t } = useTranslation();
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('nl-NL');
  };

  const isTooOld = isMessageTooOld(message.verzonden_datumtijd);

  const handleRowClick = (e) => {
    const isShift = e.shiftKey;
    onToggle(message.id, index, isShift);
  };

  return (
    <tr 
      className={`message-row ${isSelected ? 'selected' : ''} ${isTooOld ? 'message-too-old' : ''}`}
      onClick={handleRowClick}
      style={isTooOld ? { opacity: 0.5 } : {}}
      title={isTooOld ? 'Dit bericht is ouder dan 2 maanden en kan niet worden gedownload' : ''}
    >
      <td className="px-4 py-3">
        <input
          type="checkbox"
          checked={isSelected}
          readOnly
          className="w-4 h-4 cursor-pointer"
        />
      </td>
      <td className="px-4 py-3">{message.type}</td>
      <td className="px-4 py-3">{message.displayNaamVerzend}</td>
      <td className="px-4 py-3" style={{ display: hasScsnValues ? 'table-cell' : 'none' }}>{message.glN_zender}
        <CopyBtn text={message.glN_zender}/>
      </td>
      <td className="px-4 py-3">{message.displayNaamOntvangt}</td>
      <td className="px-4 py-3" style={{ display: hasScsnValues ? 'table-cell' : 'none' }}>{message.glN_ontvanger}
        <CopyBtn text={message.glN_ontvanger}/>
      </td>
      <RenderOnRole roles= {["Administrator", "SD_Medewerker"]}>
        <td className="px-4 py-3 font-mono text-sm">{message.id}
        <CopyBtn text={message.id}/>
        </td>
      </RenderOnRole>
      <td className="px-4 py-3 font-mono text-sm">{message.functioneelID}
        <CopyBtn text={message.functioneelID}/>
      </td>
      <td className="px-4 py-3">
        <span className={`status-badge ${GetMessageStatusColor(message.status)}`}>
          {(() => {
            let key = getStatusTranslationKey(message.status);
            // For Klant users, show "delivered" for status 5 (manuallyProcessed)
            if (message.status === "5" && UserService.hasRole(['Klant'])) {
              key = 'delivered';
            }
            return t(`messageStatuses.${key}`);
          })()}
        </span>
      </td>
      <td className="px-4 py-3 text-sm">{formatDate(message.verzonden_datumtijd)}</td>
      <td className="px-4 py-3 text-sm">{formatDate(message.ontvangen_datumtijd)}</td>
      <RenderOnRole roles= {["Administrator", "SD_Medewerker"]}>
        <td className="px-4 py-3 text-sm">{message.agentname}</td>
      </RenderOnRole>
    </tr>
  );
};

export default MessageRow;